import React from 'react';

import classnames from 'classnames';

import './NewPlanCountdown.scss';

import { Link } from 'react-router-dom';

import ReduxConnect from 'Demora/redux-connect';

import launchDate from './launchDate';

class NewPlanCountdown extends React.Component {
	constructor() {
		super();

		this.state = {
			days: '',
			hours: '',
			launched: false,
			minutes: '',
			seconds: '',
		};
	}

	componentDidMount() {
		this.countDownDate(true);
	}

	countDownDate = (first) => {
		const timeleft = this.getEndDate().getTime() - new Date().getTime();

		if (timeleft < 0) {
			clearInterval(this.interval);
			this.setState({
				launched: true,
			});
			if (!first && this.props.onCountdownZero) {
				this.props.onCountdownZero();
			}
			return;
		}

		const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
		const hours = Math.floor(
			(timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
		);
		const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeleft % (1000 * 60)) / 100) / 10;

		this.setState({
			days,
			hours,
			minutes,
			seconds,
		});

		if (!this.interval) {
			this.interval = setInterval(this.countDownDate, 90);
		}
	};

	getStartDate() {
		return new Date(Date.UTC(2023, 4, 19, 17, 0, 0));
	}

	getEndDate() {
		return launchDate();
	}

	getLaunchDate = () => {
		const d = this.getEndDate();

		const months = [
			'Jan',
			'Feb',
			'Mar',
			'Apr',
			'May',
			'Jun',
			'Jul',
			'Aug',
			'Sep',
			'Oct',
			'Nov',
			'Dec',
		];

		const year = d.getFullYear();
		const date = d.getDate();
		const month = months[d.getMonth()];
		const hour = d.getHours().toString().padStart(2, '0');
		const minute = d.getMinutes().toString().padStart(2, '0');

		return `${month} ${date} ${year} ${hour}:${minute}`;
	};

	render() {
		const state = this.state;

		const sec = state.seconds.toFixed && state.seconds.toFixed(1);

		const props = this.props;

		if (this.getStartDate().getTime() > new Date().getTime()) {
			return null;
		}

		let launched = false;

		if (state.launched || this.getEndDate().getTime() <= new Date().getTime()) {
			if (
				this.getEndDate().getTime() + 1000 * 60 * 60 * 72 <
				new Date().getTime()
			) {
				return null;
			}

			if (props.dontShowLaunched) {
				return null;
			}

			launched = true;
		}

		return (
			<div
				className={classnames(
					'NewPlanCountdown d-flex justify-content-center',
					props.className
				)}
				style={props.style}
			>
				<div
					className={classnames(
						'NewPlanCountdown-inner text-white',
						props.classNameInner
					)}
				>
					<div className='text-center'>
						<h1>
							{launched
								? 'CashJuice Has Relaunched!'
								: 'The Countdown Has Begun!'}
						</h1>
						<h4>
							{launched ? 'Relaunch Date Was' : 'Register Now For The Relaunch'}
							<br />
							<br />
							{this.getLaunchDate()}
							{launched && (
								<div className='mt-4 mb-3'>
									Click the button to find out what's NEW!
								</div>
							)}
						</h4>
					</div>
					{!launched && (
						<div className='countdown d-flex justify-content-center'>
							<div>
								<h3>{state.days}</h3>
								<h4>Days</h4>
							</div>
							<div>
								<h3>{state.hours}</h3>
								<h4>Hours</h4>
							</div>
							<div>
								<h3>{state.minutes}</h3>
								<h4>Minutes</h4>
							</div>
							<div>
								{!!sec && (
									<h3
										className='text-sm-right d-flex'
										style={{ marginRight: '2px' }}
									>
										<div className='flex-grow-1'>{sec.split('.')[0]}</div>
										<div className='d-none d-sm-block' style={{ width: '5px' }}>
											.
										</div>
										<div
											className='d-none d-sm-block'
											style={{ width: '35px' }}
										>
											{sec.split('.')[1]}
										</div>
									</h3>
								)}
								<h4>Seconds</h4>
							</div>
						</div>
					)}
					<div className='text-center'>
						{!!this.props.user && !this.props.dontShowRegisterButton && (
							<Link
								type='button'
								className='btn btn-danger btn-xlg'
								to='/relaunch'
							>
								{launched ? 'Check out the relaunch!' : 'Register Now'}
							</Link>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default ReduxConnect(NewPlanCountdown, {
	user: 'user',
});
